import Vue from 'vue'
import { getImageUrl } from 'util/media-utils'
import mediaMixin from './media-mixin'

import withRender from './media-thumb.html'
import './media-thumb.scss'


export default withRender(Vue.extend({
  data() {
    return { isImageLoaded: false }
  },
  props: {
    altText: String
  },
  mixins: [mediaMixin],
  computed: {
    imageStyles() {
      if (this.isImage) {
        // even though thumbnails are square, need to explicitly set width and height due to
        // differences in how IE interprets max-width 100% compared to other browsers.
        return this.itemStyles
      }
      const dims = this.getPanAndZoomDimensions(
        this.media.thumbnailWidth,
        this.media.thumbnailHeight,
        this.size,
        this.size
      )
      const newWidth = dims.width
      const newHeight = dims.height
      // we need to adjust the top or left to fit in the square
      const { top, left } = this.getImagePositioning(newWidth, newHeight, this.size, this.size)
      const allStyles = {
        position: 'absolute',
        'max-width': 'none',
        width: newWidth,
        height: newHeight,
        top,
        left
      }
      return this.getStyleString(allStyles)
    },
    itemStyles() {
      return this.getStyleString({ width: this.size, height: this.size })
    },
    imageSrc() {
      if (this.isImage) {
        return getImageUrl(this.media, 'PZ320')
      }
      return this.media.thumbnailUrl // video
    }
  },
  methods: {
    onImageLoad() {
      this.isImageLoaded = true
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/media/media-thumb.ts